import { render } from "./Tip.vue?vue&type=template&id=30f0a8dc&scoped=true"
import script from "./Tip.vue?vue&type=script&lang=ts"
export * from "./Tip.vue?vue&type=script&lang=ts"

import "./Tip.vue?vue&type=style&index=0&id=30f0a8dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30f0a8dc"

export default script